import FreemiumEventTutorialGroupVideoStep from './FreemiumEventTutorialGroupVideoStep';

export default FreemiumEventTutorialGroupVideoStep;
